module.exports = __webpack_public_path__ + "../static/media/agenda.0f2ac847.png";